<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Title:</h4>
            <input type="text" width="100px" v-model="$parent.mediaProperty.configuration.title" @change="save" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Size (diameter of the piechart)*: </h4><input type="text" v-model="$parent.mediaProperty.configuration.size" @change="save" :disabled="!$parent.mediaProperty.isActive"/>
            <p class="validationMessage" v-if="!$parent.mediaProperty.configuration.size && $parent.mediaProperty.configuration.size !== 0">*This field is required</p>
        </div>
        <div class="formRow">
            <h4>Show Legend:</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.showLegend" @change="toggleShowLegend" :disabled="!$parent.mediaProperty.isActive">
        </div>
        <div class="childObject" v-if="$parent.mediaProperty.configuration.legendProperties">
            <div class="formRow">
                <h4>Legend Location*:</h4>
                <select v-model="$parent.mediaProperty.configuration.legendProperties.legendLocation" @change="save" :disabled="!$parent.mediaProperty.isActive">
                    <option value="Left">Left</option>
                    <option value="Right">Right</option>
                </select>
            </div>
            <div class="formRow">
                <h4>Show Border:</h4>
                <input type="checkbox" v-model="$parent.mediaProperty.configuration.legendProperties.showBorder" @change="save" :disabled="!$parent.mediaProperty.isActive">
            </div>
            <div class="formRow">
                <h4>Border Color:</h4>
                <input type="text" width="100px" v-model="$parent.mediaProperty.configuration.legendProperties.borderColor" @change="save" :disabled="!$parent.mediaProperty.isActive"/>
                <div class="colorSample" :style="{'background': $parent.mediaProperty.configuration.legendProperties.borderColor, 'background-color': $parent.mediaProperty.configuration.legendProperties.borderColor}"></div>
            </div>
        </div>
        <h4>
            Pie Slices:   
            <button class="addRowButton" @click="addPieSlice" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i>Add Slice</button>
        </h4>
        <div class="datagrid" v-if="$parent.mediaProperty.configuration.pieSlices">       
                <div class="gridRow">
                    <div class="dataCell header tiny"></div>
                    <div class="dataCell header medium">Percentage</div>
                    <div class="dataCell header medium">Color</div>
                    <div class="dataCell header large">Label</div>
                    <div class="dataCell header small">&nbsp;</div>
                </div>
                <VueDraggableNext class="dragArea list-group w-full" :list="$parent.mediaProperty.configuration.pieSlices" @update="moveElement" >        
                    <div v-for="(slice, index) in sortedSlices" :key="index" class="gridRow draggable">
                        <div class="dataCell tiny" :class="getGridClass(index)">
                            <i class="fa-solid fa-grip-vertical"></i>
                        </div>
                        <div class="dataCell medium" :class="getGridClass(index)">
                            <input type="number" v-model="slice.percentage" @change="save" :disabled="!$parent.mediaProperty.isActive"/>
                        </div>
                        <div class="dataCell medium" :class="getGridClass(index)" >
                            <input type="text" style="width: 65px" v-model="slice.color" @change="save" :disabled="!$parent.mediaProperty.isActive"/>
                            <div class="colorSample" :style="{'background': slice.color, 'background-color': slice.color}"></div>
                        </div>
                        <div class="dataCell large" :class="getGridClass(index)">
                            <input type="text" style="width: 200px" v-model="slice.label" @change="save" :disabled="!$parent.mediaProperty.isActive"/>
                        </div>
                        <div class="dataCell small" :class="getGridClass(index)">
                            <button class="deleteButton" @click="deletePieSlice(index)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                        </div>
                    </div>
                </VueDraggableNext>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import { VueDraggableNext} from 'vue-draggable-next';

export default {
    name: 'PieChartEdit',
    components: { VueDraggableNext },
    data: function() {
        return {
            
        }
    },
    mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                title: '',
                size: 0, 
                borderColor: '',
                showLegend: false,
                legendProperties: null,
                pieSlices: []
            }
        }       
    },
    computed: {
        sortedSlices() {
            var slices = this.$parent.mediaProperty.configuration.pieSlices;
            slices.sort((a, b) => { return a.sequence-b.sequence });
            return slices;
        },
    },
    methods: {
        moveElement: function(evt) {
            this.array_move(this.$parent.mediaProperty.configuration.pieSlices, evt.oldIndex, evt.newIndex);          
            for(var i = 0; i < this.$parent.mediaProperty.configuration.pieSlices.length; i++)
                this.$parent.mediaProperty.configuration.pieSlices[i].sequence = i + 1;
            
            this.save();         
        },       
        array_move: function(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
        },
        reorderElements: async function(oldSequence, newSequence) {
            var savedElement = this.$parent.mediaProperty.configuration.pieSlices[oldSequence];
            this.$parent.mediaProperty.configuration.pieSlices.slice(oldSequence, 1); 
            if(oldSequence < newSequence && newSequence > this.$parent.mediaProperty.configuration.pieSlices.length - 1)
                this.$parent.mediaProperty.configuration.pieSlices.push(savedElement)
            else if(oldSequence < newSequence)
                this.$parent.mediaProperty.configuration.pieSlices.slice(newSequence - 1, 1, savedElement);
            else 
                this.$parent.mediaProperty.configuration.pieSlices.slice(newSequence, 1, savedElement);

            for(var i = 1; i < this.$parent.mediaProperty.configuration.pieSlices.length; i++)
                this.$parent.mediaProperty.configuration.pieSlices[i].sequence = i;
        },

        getGridClass: function(index) {
            if(index === this.$parent.mediaProperty.configuration.pieSlices.length - 1)
                return "last"
            else 
                return "";
        },
        save: async function() {
            const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
            if(!this.$parent.mediaProperty.id && resp.id) {
                this.$parent.mediaProperty.id = resp.id;
                this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
            }
        },
        toggleShowLegend: function() {
            if(this.$parent.mediaProperty.configuration.showLegend === true) {
                if(this.$parent.mediaProperty.configuration.legendProperties == null)
                    this.$parent.mediaProperty.configuration.legendProperties = { legendLocation: "Left"};        
            }
            else {
                this.$parent.mediaProperty.configuration.legendProperties = null;
                this.save();
            }
        },
        sequenceMinus: function(obj, parentArr) {
            if(!parentArr)
                parentArr = this.$parent.mediaProperty.configuration.pieSlices;
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].sequence === (obj.sequence - 1))
                    parentArr[i].sequence++;
            }
            if(obj.sequence > 1)
                obj.sequence --;
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
            this.save();
        },
        sequencePlus: function(obj, parentArr) {
            if(!parentArr)
                parentArr = this.$parent.mediaProperty.configuration.pieSlices;
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].sequence === (obj.sequence + 1))
                    parentArr[i].sequence--;
            }
            if(obj.sequence < parentArr.length)
                obj.sequence ++;
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
            this.save();
        },
        addPieSlice: function() {
            if(!this.$parent.mediaProperty.configuration.pieSlices) this.$parent.mediaProperty.configuration.pieSlices = [];
            const newSequence = this.$parent.mediaProperty.configuration.pieSlices.length > 0 ? 
                this.$parent.mediaProperty.configuration.pieSlices[this.$parent.mediaProperty.configuration.pieSlices.length - 1].sequence + 1 : 1;
            this.$parent.mediaProperty.configuration.pieSlices.push({
                sequence: newSequence
            });
        },
        deletePieSlice: function(index) {
            if(confirm('Are you sure you want to delete this slice?')){
                this.$parent.mediaProperty.configuration.pieSlices.splice(index, 1);
                this.save();
            }
        }
    }
}
</script>

<style scoped>

h4 {
    margin: 10px 0px;
}
.datagrid {
    display: flex;
    flex-direction: column;
}

.datagrid div.dataCell {
    display: flex;
    flex-direction: row;
    border: none;
    border-top: solid 1px;
    padding: 10px;
}

.tiny {
    flex: 0 0 20px;
    align-items: center;
}
.small { 
    flex: 0 0 60px;
}

.medium { 
    flex: 0 1 100px;
}
.large { 
    flex: 0 1 250px;
}

div.dataCell input {
    padding: 0px 5px;
}

.datagrid div.dataCell.last {
    border-bottom: solid 1px;
}

.datagrid div.dataCell.header {
    background-color: #a9a9a9;
    font-weight: bold;
    justify-content: left;
}

    div.dataCell .deleteButton {
        display: flex;
        position: relative;
        padding: 5px;
        bottom: unset;
        top: unset;
        right: unset;
    }

    div.dataCell div.colorSample {
        margin-left: 5px;
        height: 20px;
        width: 20px;
        align-self: center;
    }

    .gridRow {
        display: flex;
        flex-direction: row;
    }
</style>